import lessonApi from '@/api/lesson'

const lesson={
  namespaced:true,
  state:{
    data:[],
    pagination:{current:1,total:0,pageSize:10,showSizeChanger:true,showTotal:total=>`总计 ${total} 条`},
    loading:false,
    editLesson:{roomType:0,feeMode:0},
    sorter:{},
    baseinfos:[],
    schools:[],
  },
  mutations:{
    setData:(state,data)=>{
      state.data=data
    },
    setPagination:(state,pagination)=>{
      state.pagination=pagination
    },
    setLoading:(state,loading)=>{
      state.loading=loading
    },
    edit:(state,data)=>{
      state.disabled=false
      state.editLesson=data
    },
    setSorter:(state,sorter)=>{
      state.sorter=sorter
    },
    setBaseInfos:(state,infos)=>{
      state.baseinfos=infos
    },
    setSchools:(state,schools)=>{
      state.schools=schools
    }
  },
  actions:{
    async GetAll({ commit,state },pagination){
      commit('setLoading',true)
      const page={
        skipCount:pagination.pageSize*(pagination.current-1),
        maxResultCount:pagination.pageSize,
        ...pagination
      }           
      if(state.sorter.field){
        if(state.sorter.order==='ascend'){
          page.sorting=state.sorter.field
        }else{
          page.sorting=state.sorter.field+' desc'
        }
      }
      try{
        const res=await lessonApi.getAll(page)
        pagination.total=res.result.totalCount
        commit('setPagination',pagination)
        commit('setData',res.result.items)
      }finally {
        commit('setLoading',false)
      }
    },
    async UpdateOrAdd({ commit,dispatch,state },lesson){
      try{
        if(lesson.id){
          await lessonApi.update(lesson)          
        }else{
          await lessonApi.create(lesson)
        }
        commit('edit',{})
        await dispatch('GetAll',state.pagination)
      }catch(err){
        throw err
      }     
    },
    async Delete({ dispatch,state },lesson){
      await lessonApi.delete(lesson.id)
      await dispatch('GetAll',state.pagination)
    },
    async GetBaseInfos({ commit },where){
      const res=await lessonApi.getBaseInfos(where)
      commit('setBaseInfos',res.result.items)
    },
    async GetSchools({ commit }){
      const res=await lessonApi.getSchools()
      commit('setSchools',res.result.items)
    }
  }
}
export default lesson